import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import process from 'process';
import { Buffer } from 'buffer';
import "./index.css"; // 確保正確導入 CSS 文件

window.process = process;
window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById("root"));

const devToolsWarning = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
if (typeof devToolsWarning === 'object') {
    devToolsWarning.inject = function() {};
}

if (process.env.NODE_ENV === 'production') {
  console.warn = () => {};
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);